var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit07(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1025 6.41302L15.5165 4.99902L20.1065 9.58502L18.6945 10.999L14.1025 6.41302Z",
    fill: "#C3C9D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5753 4.76302L6.71027 15.628L5.79027 19.313L9.47427 18.392L20.3393 7.52702L17.5753 4.76302ZM23.1033 7.52702L10.4733 20.157L3.10327 21.999L4.94627 14.629L17.5753 1.99902L23.1033 7.52702Z",
    fill: "#C3C9D2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit07);
export default __webpack_public_path__ + "static/media/edit.07.52abd815b6a9531c3de47454d0c98129.svg";
export { ForwardRef as ReactComponent };